import { render, staticRenderFns } from "./prestamoDetail.vue?vue&type=template&id=0960e776"
import script from "./prestamoDetail.vue?vue&type=script&lang=js"
export * from "./prestamoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports